module.exports = __webpack_public_path__ + "static/sport/icon.7768784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/icon.png
// module id = ei3M
// module chunks = 0